import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment, masters } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StudentEnrollmentStatusService {

 
  constructor(private http:HttpClient) { }

  StudentEnrollmentStatusDropdown() {
    return this.http.get(`${environment.baseUrl}${masters.getEnrollmentStateusDropdown}`);
  }
}




  
